import { useMemo } from 'react';

import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { type TimeZoneConfiguration } from 'hb-react/types/timeZoneConfiguration';

const useTimeZoneConfiguration = (): TimeZoneConfiguration => {
  const { currentUser, currentNetwork } = useDefaultAppContexts();

  const eventDatesInUserTimezone =
    currentNetwork?.network_configuration?.events
      ?.display_event_dates_in_user_timezone_enabled ?? false;

  const userTimeZone = useMemo(
    () =>
      currentUser?.timezone ?? Intl.DateTimeFormat().resolvedOptions().timeZone,
    [currentUser],
  );

  return useMemo(
    () => ({
      currentUserTimezone: userTimeZone,
      eventDatesInUserTimezone,
    }),
    [userTimeZone, eventDatesInUserTimezone],
  );
};

export default useTimeZoneConfiguration;
